import styles from './SupplyDemandFooter.css';
import { UIText2 } from '@cian/ui-kit';

export function SupplyDemandFooter() {
  return (
    <div className={styles['container']}>
      <UIText2 color="gray60_100">
        График показывает значения относительно прошлогоднего уровня, принятого за 100%
      </UIText2>
    </div>
  );
}
